export const KEY_RECOVERY_LOG = 'recovery-logs';
export const KEY_RECOVERY_ATTEMPS = 'recovery-attemps';
export const KEY_RECOVERY_LAST_RECOVERY_TIME = 'last-recovery-time';
export const KEY_RECOVERY_HISTORY = 'recovery-history';
export const KEY_RECOVERY_TEST = 'teste-recovery';